import { render, staticRenderFns } from "./DepaList.vue?vue&type=template&id=57ec4f35&scoped=true"
import script from "./DepaList.vue?vue&type=script&lang=js"
export * from "./DepaList.vue?vue&type=script&lang=js"
import style0 from "./DepaList.vue?vue&type=style&index=0&id=57ec4f35&prod&lang=scss&scoped=true"
import style1 from "./DepaList.vue?vue&type=style&index=1&id=57ec4f35&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ec4f35",
  null
  
)

export default component.exports